// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopRelationalTariffProfileControllerGetAllData } from './EshopRelationalTariffProfileControllerGetAllData.gen';
import type { EshopRelationalTariffProfileControllerGetAllErrors } from './EshopRelationalTariffProfileControllerGetAllErrors.gen';
import type { EshopRelationalTariffProfileControllerGetAllResponses } from './EshopRelationalTariffProfileControllerGetAllResponses.gen';
import type { Options } from './Options.gen';

export class EshopRelationalTariffProfileController {
    /**
     * Get tariff profiles.
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<EshopRelationalTariffProfileControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopRelationalTariffProfileControllerGetAllResponses, EshopRelationalTariffProfileControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/relational-tariff-profiles',
            ...options
        });
    }
}
